// extracted by mini-css-extract-plugin
module.exports = {"page":"LoginPage_page__36QpI"};